import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getUserWalletsLoadingState = (state: RootState): RootState['userWallets']['loading'] =>
  state.userWallets.loading

export const userWalletsIsLoading = createSelector(
  getUserWalletsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getUserWalletsData = (state: RootState): RootState['userWallets']['data'] => state.userWallets.data
export const getUserWalletsError = (state: RootState): RootState['userWallets']['error'] => state.userWallets.error
